import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-card-badge-rivoneed';
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-show="true" data-attribute="card-title" class="card-title">
      <h2 style="text-align: center">Risk-Free Purchase, Peace of Mind</h2>
      <p style="text-align: center">30-Day Money-Back Guarantee</p>
    </div>
    <div data-attribute="list-item" class="list-item">
      <div data-attribute="item" class="item">
        <div class="icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fb04bed73b6428256aeef.png"
            alt=""
          />
        </div>
        <div data-attribute="content-item" class="content">
          <h3 style="text-align: center">30-Day Money-Back Guarantee</h3>
          <p style="text-align: center">Should we not meet your expectations, we offer a full refund within 30 days.</p>
        </div>
      </div>
      <div data-attribute="item" class="item">
        <div class="icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fb051ff65ed9dee3321b7.png"
            alt=""
          />
        </div>
        <div data-attribute="content-item" class="content">
          <h3 style="text-align: center">24/7 Quality Customer Service</h3>
          <p style="text-align: center">Our quality customer service team is here to help you 24 hours a day.</p>
        </div>
      </div>
      <div data-attribute="item" class="item">
        <div class="icon">
          <img
            data-attribute="icon-item"
            src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fb056632dc76f035c3113.png"
            alt=""
          />
        </div>
        <div data-attribute="content-item" class="content">
          <h3 style="text-align: center">Powered by Real Users</h3>
          <p style="text-align: center">
            Real-user experience drives our development and testing to create the ultimate solution.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#1a1a1a',
  textColor: '#ffffff',
});
